import {useImageOverlayMapLayerProvider} from "base/component/geo";

import {createImageOverlayLayerLegend, useImageOverlayLayerObject} from "base/map";
import SquareIcon from "@mui/icons-material/Square";

const layersBounds = [
    [35.0, -14.000000001],
    [65.833333333, 26.666666667000005],
];

export function useFishinggvaMapProvider(config) {
    const layer = useImageOverlayLayerObject({
        opacity: 0.5,
        imageUrl: "/images/Fishinggva.png",
        imageBounds: layersBounds,
        legend: createImageOverlayLayerLegend({
            layerName: "Fishing GVA",
            layerType: "rst",
            legendItems: [
                {
                    label: "(€ million)",
                    color: "white",
                    icon: null,
                },
                {
                    label: "<=0,0190",
                    color: "#ffe3d8",
                    icon: <SquareIcon sx={{fontSize: "0.8rem"}} />,
                },
                {
                    label: "0,0190 - 0,0960",
                    color: "#f2cfc2",
                    icon: <SquareIcon sx={{fontSize: "0.8rem"}} />,
                },
                {
                    label: "0,0960 - 0,4500",
                    color: "#f1af93",
                    icon: <SquareIcon sx={{fontSize: "0.8rem"}} />,
                },
                {
                    label: "0,4500 - 1,2800",
                    color: "#ee7649",
                    icon: <SquareIcon sx={{fontSize: "0.8rem"}} />,
                },
                {
                    label: "1,2800 - 4,1200",
                    color: "#ca5134",
                    icon: <SquareIcon sx={{fontSize: "0.8rem"}} />,
                },
                {
                    label: "> 4,1200",
                    color: "#952e16",
                    icon: <SquareIcon sx={{fontSize: "0.8rem"}} />,
                },
            ],
        }),
    });
    const [provider] = useImageOverlayMapLayerProvider(layer, config);

    return provider;
}
